import "./Tuyendung.css";
const stats = [
  ['100%', 'Khách hàng có sẵn từ quảng cáo'],
  ['8h–20h', 'Thời gian làm việc, nghỉ trưa 12h–13h'],
  ['Ngày 10', 'Nhận lương qua chuyển khoản hằng tháng'],
  ['15tr+', 'Lương khởi điểm + thưởng + hoa hồng'],
];

export default function Start() {
  return (
    <div className="stats">
      <div className="wrap stats-grid">
        {stats.map(([number, label]) => (
          <div className="stat-item" key={number}>
            <div className="stat-num">{number}</div>
            <div className="stat-label">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}